module.exports = __webpack_public_path__ + "img/2020etj.a0ba373f.jpg";